import FormSelect from 'components/ui/composed/declarations/formSelect/DeclarationSelect';
import { ReactElement, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DeclarationField from 'views/declarations/common/DeclarationField';
import { getFormikProps } from 'views/declarations/utils/form-utils';
import useCodelists from '../../../../../hooks/useCodelists';
import HideComponent from '../../../../../utils/HideComponent';
import { ValidationSchema, validators } from '../validations/validations';

type Fields = 'specificCircumstancesCodeCode';

export const specificCircumstanceIndicatorBlockValidation: ValidationSchema<Fields> = {
    childValidators: {
        specificCircumstancesCodeCode: [validators.exact(3)],
    },
};

interface Props extends BlockProps<Fields> {}

const SpecificCircumstanceIndicatorBlock = ({ hide }: Props): ReactElement => {
    const { t } = useTranslation('form');
    const { cdsCodelists } = useCodelists();

    const ucc = useMemo(() => '1/7', []);

    return (
        <HideComponent hide={hide}>
            <DeclarationField name="specificCircumstancesCodeCode">
                {({ form, field }) => (
                    <FormSelect
                        {...getFormikProps(field.name, form)}
                        refNumber={ucc}
                        label={t('specificCircumstanceIndicator')}
                        selectOptions={cdsCodelists?.specificCircumstanceTypes}
                        condensed
                        codeValidation={[validators.exact(3)]}
                    />
                )}
            </DeclarationField>
        </HideComponent>
    );
};

export default SpecificCircumstanceIndicatorBlock;
